{
  "version": 1,
  "asset_id": "c5d9e469-e8b2-475a-8c96-ec64b3987339",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/c5d9e469-e8b2-475a-8c96-ec64b3987339/sleeve-hiatal-type-1-es-600.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/c5d9e469-e8b2-475a-8c96-ec64b3987339/sleeve-hiatal-type-1-es-600.jpg",
  "original_filename": "sleeve-hiatal-type-1-es-600.jpg",
  "size": 71733,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T21:38:44Z"
}
